module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmh",
    attrs: {
      "id": "toc"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/title#tit",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Title Page")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/copyrightnotice#notice",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Copyright Notice")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ded#ded"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Dedication")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/intro#int"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Introduction:")]), _vm._v(" T"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("HE")]), _vm._v(" G"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ODS OF")]), _vm._v(" C"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("OMEDY")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#ch1"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Chapter 1:")]), _vm._v(" H"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("OCKEY")]), _vm._v(" N"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("IGHT IN")]), _vm._v(" C"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ALIFORNIA")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter2#ch2"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Chapter 2:")]), _vm._v(" M"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ELONVILLE")]), _vm._v(" D"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("AYS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter3#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Chapter 3:")]), _vm._v(" T"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("HE")]), _vm._v(" J"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("OLLY")]), _vm._v(" J"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ESTER")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Chapter 4:")]), _vm._v(" M"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("Y")]), _vm._v(" K"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("IND OF")]), _vm._v(" T"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("OWN")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Chapter 5:")]), _vm._v(" K"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ID")]), _vm._v(" S"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TUFF")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter6#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Chapter 6:")]), _vm._v(" “SCTV I"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("S")]), _vm._v(" O"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("N")]), _vm._v(" T"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("HE")]), _vm._v(" A"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("IR")]), _vm._v("!”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter7#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Chapter 7:")]), _vm._v(" A"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("T")]), _vm._v(" L"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ARGE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter8#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Chapter 8:")]), _vm._v(" I"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("T")]), _vm._v(" C"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("AME")]), _vm._v(" F"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ROM")]), _vm._v(" E"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("DMONTON")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter9#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Chapter 9:")]), _vm._v(" G"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("OING")]), _vm._v(" B"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ERSERK")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Chapter 10:")]), _vm._v(" A"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("LL")]), _vm._v(" A"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("BOUT")]), _vm._v(" S"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PLASH")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Chapter 11:")]), _vm._v(" F"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("LIRTING")]), _vm._v(" W"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ITH")]), _vm._v(" D"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ISASTER")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Chapter 12:")]), _vm._v(" P"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("LANES")]), _vm._v(", T"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("RAINS")]), _vm._v(" A"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ND")]), _vm._v(" J"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("OHN")]), _vm._v(" H"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("UGHES")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Chapter 13:")]), _vm._v(" S"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("UNSET")]), _vm._v(" B"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("OULEVARD")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Chapter 14:")]), _vm._v(" N"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("OTHING")]), _vm._v(" B"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("UT")]), _vm._v(" T"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ROUBLE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Chapter 15:")]), _vm._v(" T"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("OUCHDOWN")]), _vm._v(" F"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EVER")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter16#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Chapter 16:")]), _vm._v(" J"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("OHN’S")]), _vm._v(" G"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ALLOWS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Chapter 17:")]), _vm._v(" J"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("OHNNY")]), _vm._v(" T"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ORONTO")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter18#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Chapter 18:")]), _vm._v(" O"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("UT OF")]), _vm._v(" B"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("REATH")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bot"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/epilogue#epil",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Epilogue")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/film#film",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Filmography")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/source#source",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("A Note on Sources")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ack#ack",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index#ind",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Index")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/copyright#crp",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Copyright")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef6128c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 63
// module chunks = 0